import { render, staticRenderFns } from "./CheckoutShipping.vue?vue&type=template&id=1f60319a&scoped=true&"
import script from "./CheckoutShipping.vue?vue&type=script&lang=js&"
export * from "./CheckoutShipping.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutShipping.vue?vue&type=style&index=0&id=1f60319a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f60319a",
  null
  
)

export default component.exports